module.exports = __webpack_public_path__ + "img/3-questions.dcc22ebc.svg";